import { EnumMyleLoginPermission } from "../EnumMyleLoginPermission";
import { MyleTabKey } from "./enums/MyleTabKey";
import { MyleMenuTabTooltip } from "./Tooltip/MyleMenuTabTooltip";

class MyleMenuTabItem {
    /**
     * The unique key which identifies the tab and matches the vocab key of the display text.
     */
    public key: MyleTabKey;

    /**
     * The tab URL path relative to the server root, without the "/".
     */
    public path: string;

    /**
     * The user permissions which enable access to this tab. The user has access if they have *any* of these, or the list is empty.
     */
    public permissions: EnumMyleLoginPermission[];

    /**
     * Whether to show count badges on the tab.
     */
    public showCounts: boolean;

    /**
     * The top badge count.
     */
    public topCount: number;

    /**
     * The bottom badge count.
     */
    public bottomCount: number;

    /**
     * The bottom aside count represents the amount of faxes received marked as urgent.
     */
    public bottomCountUrgentUnmanagedFaxes: number;

    /**
     * The top aside badge count represents the amount of faxes received.
    */
    public topCountUnmanagedFaxes: number;

    /**
     * The bottom aside count represents the amount of pending items received marked as urgent.
     */
    public bottomUrgentPendingCount: number;

    /**
      * The top aside badge count represents the amount of pending items received.
     */
    public topPendingCount: number;

    /**
     * Whether the user is prevented from clicking the tab.
     */
    public isLocked: boolean = false;

    /**
      * The counters information to be displayed on the tooltip.
     */
    public tooltip?: MyleMenuTabTooltip;

    constructor(opts: Partial<MyleMenuTabItem>) {
        this.key = opts.key;
        this.path = opts.path;
        this.permissions = opts.permissions || [];

        this.showCounts = opts.showCounts || false;
        this.topCount = opts.topCount || 0;
        this.bottomCount = opts.bottomCount || 0;
        this.topPendingCount = opts.topPendingCount || 0;
        this.bottomUrgentPendingCount = opts.bottomUrgentPendingCount || 0;
        this.isLocked = opts.isLocked || false;
        this.tooltip = opts.tooltip;
    }
}

export { MyleMenuTabItem };
